import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=0d27aeac&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
import style0 from "./pagination.vue?vue&type=style&index=0&id=0d27aeac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27aeac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d27aeac')) {
      api.createRecord('0d27aeac', component.options)
    } else {
      api.reload('0d27aeac', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=0d27aeac&scoped=true", function () {
      api.rerender('0d27aeac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pagination.vue"
export default component.exports